export default {
  freeReturn: {
    id: 'product_reassurance_buttons_free_return',
    defaultMessage: '{day}-days free return',
  },
}
